module.exports = __webpack_public_path__ + "static/media/networth_without_house.9ca2f4c6.png";